var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    stroke: "#4C4C4C",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.997 6.325-.765-2.856a.633.633 0 1 0-1.224.329l.378 1.409c-3.569-1.784-7.952-.508-9.973 2.992a7.552 7.552 0 0 0-.946 4.793.641.641 0 0 0 .798.543c.3-.08.508-.368.465-.676a6.29 6.29 0 0 1 .78-4.027c1.661-2.875 5.25-3.952 8.2-2.55l-1.344.36a.633.633 0 1 0 .328 1.223l2.855-.764a.634.634 0 0 0 .448-.776M6.996 17.675l.765 2.856a.633.633 0 1 0 1.224-.329l-.377-1.409c3.568 1.784 7.95.508 9.972-2.992a7.552 7.552 0 0 0 .946-4.793.641.641 0 0 0-.798-.543.622.622 0 0 0-.465.675 6.29 6.29 0 0 1-.78 4.027c-1.66 2.876-5.25 3.952-8.2 2.551l1.344-.36a.632.632 0 1 0-.328-1.223l-2.855.764a.634.634 0 0 0-.448.776"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.732f3cdd06a615864dec59e416273869.svg";
export { ForwardRef as ReactComponent };